import { render, staticRenderFns } from "./YA_User.vue?vue&type=template&id=9791a92e&scoped=true"
import script from "./YA_User.vue?vue&type=script&lang=js"
export * from "./YA_User.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9791a92e",
  null
  
)

export default component.exports